import { defineMessages } from 'react-intl'

export const AboutMessages = defineMessages({
  aboutHeader: {
    id: 'about.aboutHeader',
    description: 'Header for "About" page',
    defaultMessage: 'About Company',
  },
  contactPhone: {
    id: 'about.contactPhone',
    description: 'Company phone',
    defaultMessage: 'Contact Phone: {phone}',
  },
  contactEmail: {
    id: 'about.contactEmail',
    description: 'Company email',
    defaultMessage: 'Contact Email: {email}',
  },
  companyDisclaimer: {
    id: 'about.companyDisclaimer',
    description: 'Disclaimer on "About" page',
    defaultMessage:
      "Your company's contact details are visible to your customers and distributors. Community admin users can update this information in the Savant Community.",
  },
  companyChangeImage: {
    id: 'about.companyChangeImage',
    description: "Button text to change image on 'About Company' page",
    defaultMessage: 'Change Image',
  },
  noImage: {
    id: 'about.noImage',
    description:
      "Helper text informing there is no image on 'About Company' for company page",
    defaultMessage: 'No Image Yet',
  },
})
